// Client-side reason-validity helpers for catalog items. Resources flagged
// `requiresComment` must carry a non-blank reason before submission; the
// server re-enforces this — this is a UX guardrail, not a security boundary.

export interface ReasonValidityArgs {
  perItem: boolean;
  /** True when ≥1 *submittable* resource requires a comment. */
  anyRequiresComment: boolean;
  /** The single bulk reason (only consulted when perItem=false). */
  bulkReason: string;
  /**
   * One entry per submittable (recipient × item) cell in per-item mode:
   * the row's requiresComment flag and the reason currently entered for it.
   * Empty in bulk mode.
   */
  perItemRows: Array<{ requiresComment: boolean; reason: string }>;
}

export const isReasonInvalid = ({
  perItem,
  anyRequiresComment,
  bulkReason,
  perItemRows,
}: ReasonValidityArgs): boolean => {
  if (!perItem) return anyRequiresComment && bulkReason.trim() === "";
  return perItemRows.some(
    (row) => row.requiresComment && row.reason.trim() === "",
  );
};
